import { render, staticRenderFns } from "./DashMobileAppsNews.vue?vue&type=template&id=a601586c&scoped=true&"
import script from "./DashMobileAppsNews.vue?vue&type=script&lang=js&"
export * from "./DashMobileAppsNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a601586c",
  null
  
)

export default component.exports